import React from "react"
import ReactDOM from 'react-dom';
import TipView from "./tipView"
import { createRoot } from 'react-dom/client';
// All tooltips with trigger a custom event with product name and type of content.
const galleryPins = Array.from(document.querySelectorAll(".gallery-pin"));

galleryPins.forEach((pin) => {
	pin.addEventListener("click", (event) => {
		const contentp = document.querySelectorAll(".tooltip-box");
		var closePin = document.querySelector('.close-pin'); 
		if (event.target.classList.contains('close-pin')) {
			return false;
		}
		contentp.forEach((pinx) => {
			pinx.style.display = "none";
		});
	
		const pagebuilder = document.querySelector(".gallery-pin-container");
		var pagebuilderoffset = pagebuilder.getBoundingClientRect();

		var pagebuildercrects = pagebuilder.getClientRects();
		var pinOffsets = pin.getBoundingClientRect();

		var containerWidth = pagebuilderoffset.width;
		var pinPosition = pinOffsets.left;
		var posY = (parseFloat(pin.style.top)/100)*pagebuilderoffset.height;
	
		if( containerWidth < (pinPosition + 300) )
		{	
			const tipContent = pin.querySelector(".tooltip-box");
			tipContent.style.left = "-350px";
		
		}

		if((posY + 550) > pagebuilderoffset.height)
		{
			const tipContent = pin.querySelector(".tooltip-box");
			tipContent.style.top = "-450px";
		}
	//	console.log('pagebuilder');
	//	console.log( pagebuilderoffset );
	//	console.log( pinOffsets );
		
		var notes = pin.querySelector('.tooltip-box');
		notes.style.display = "block";
		var productId = pin.dataset.productid;
		var id = pin.dataset.id;
	  
	  var tipboxes = pin.querySelector('.tooltip-box');
	  var id1 = pin.dataset.id;
	  var tipboxRoot = createRoot(tipboxes);
	  console.log('clickedddddddddddd');

	  if( window.innerWidth  <= 1100)
	  {
		
		// tipboxes = document.querySelector('.project-popup');
		 
		var tipboxRoot = createRoot(tipboxes);
		// tipboxRoot.unmount();

		 tipboxes.innerHTML = "";
			 tipboxRoot.render(
				<div>
				<TipView id={id} productId={productId}  /> 
				</div>
				,
				tipboxes,
			);
			var tipboxesdesktop = pin.querySelector('.tooltip-box');
			//tipboxesdesktop.style.display = "none";
			document.body.classList.add('pin-body');
	  }
	  else
	  {
		
		if (!tipboxes.innerHTML) {
				// strValue was non-empty string, true, 42, Infinity, [], ...
				var tipboxRoot = createRoot(tipboxes);
				tipboxRoot.render(
						<div>
						<TipView id={id} productId={productId}  /> 
						</div>
						,
						tipboxes
					);
		}
			var tipboxesmobile = pin.querySelector('.tooltip-box');
			// tipboxesmobile.style.display = "none";
			document.body.classList.add('pin-body');
	  }
	})
})